const dragAndDropReducer = (state = { folderId: null, isDrag: null, folderPos: null}, action) => {
    switch(action.type)
    {
        case 'changeState':
            state = action.drag;
            return state;
        default :
            return state;
    }
}

export default dragAndDropReducer;